module.exports = __webpack_public_path__ + "static/media/timberRattler.e5edbbde.png";